import React from 'react'
import { Route } from 'react-router-dom'
import BusinessModel from '../../../../views/Dashboard/Configurations/BusinessManagement'

const Index = ({ match }) => (
  <div>
    <Route path={match.path} component={BusinessModel} />
  </div>
)

export default Index
